import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { getSellThruValue } from './getSellThruValue'

interface ICalculateFields {
  fields: string[]
  hpItem?: ISobCompetitor
  field: string
  value: number
}
export const calculateFields = ({
  fields,
  field,
  hpItem,
  value,
}: ICalculateFields): Record<string, number | null> => {
  return fields.reduce(
    (acc, fieldToChange) => {
      if (hpItem) {
        const hpValueSob = hpItem[field]
        const hpSellThru = hpItem[fieldToChange]
        return { ...acc, [fieldToChange]: getSellThruValue(hpValueSob, hpSellThru, value) }
      }

      return { ...acc, [fieldToChange]: null }
    },
    {} as Record<string, number | null>
  )
}
